import 'twin.macro';
import React from 'react';
import { SwitchToggle } from '@teetsh/app/src/components/Form/SwitchToggle';
import setDay from '@teetsh/app/src/utils/time/setDay';
import { format } from '@teetsh/app/src/utils/time/format';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { Chips } from '@teetsh/app/src/components/Chips';
import { css } from 'twin.macro';
import { capitalizeFirstLetter } from '@teetsh/app/src/utils/text/capitalizeFirstLetter';

interface Props {
  onChange: (v: number[]) => void;
  value: number[];
  className?: string;
}

function getAllWorkingDays(sundayStart: boolean) {
  if (sundayStart) {
    return [-1, 0, 1, 2, 3, 4, 5];
  }
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getAllWorkingDaysOptions(
  sundayStart: boolean,
  locale: UserLocale,
  pattern?: string,
) {
  return getAllWorkingDays(sundayStart).map(i => {
    const dayName = format(
      setDay(new Date(), (i + 1) % 7, sundayStart),
      locale,
      pattern || 'eeee',
    ).replace('.', '');

    return {
      value: i,
      label: capitalizeFirstLetter(dayName),
    };
  });
}

export function WorkingDaysSelector(props: Props) {
  const { onChange, value } = props;
  const { locale } = useUser();
  const { t } = useTranslation(['common']);
  const sundayStart = value.includes(-1);
  return (
    <>
      <div
        tw="mb-2 overflow-x-auto"
        css={css`
          @media (max-width: 767px) {
            ::-webkit-scrollbar {
              display: none;
            }

            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
          }
        `}
      >
        <Chips
          options={getAllWorkingDaysOptions(sundayStart, locale, 'EEE')}
          value={value}
          onChange={onChange}
          size="lg"
        />
      </div>
      <SwitchToggle
        label={t('common:components.daySelector.weekStartsOnSunday')}
        size="sm"
        onChange={(startsOnSunday: boolean) => {
          const newValue = startsOnSunday
            ? [-1, ...value.filter(d => d < 6)]
            : value.map(d => (d === -1 ? 6 : d));
          return onChange(newValue);
        }}
        checked={sundayStart}
      />
    </>
  );
}
